import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { connect, useSelector } from 'react-redux';
import { compose } from 'redux';
import moment from 'moment';
import DefaultLayoutHOC from '../layoutHOC/defaultLayout';
import { startAttempt } from '../../redux/testPage/testPage.actions';
import Loader from '../../utils/Loader';

const MyFreeActivities = ({ startAttempt }) => {

    useEffect(() => {
        Loader.hide();
    }, []);

    return (
        <div className="box elementsContainer-card freeActivities-card course-element-card gr jfm card" style={{ "width": "300px", "margin": "16px 0 0 16px" }}>
            <div>
                <div className="panel-course-default-cont themeclass-cont" style={{ "backgroundImage": "url(/assets/img/nik-shuliahin-jWCwAssgYQ4-unsplash.jpg)", "height": "150px" }}>
                    <span className="panel-course-default  theme-span">Your Daily<span>Step</span>
                    </span>
                </div>
                <div className="elementsContainer-card-def" style={{ "cursor": "pointer", "opacity": "0.8", "pointerEvents": "auto", "height": "100px" }}>
                    <div className="card-body" style={{ padding: 0 }}>
                        <div className="courseblock">
                            <div className="ourseblock-title-container">
                                <div className="courseblock-title ">Try today's free activities</div>
                            </div>
                        </div>
                        <div className="courseblock">
                            <div className="text-left courseblock-description">
                                <div className="course-desc "></div>
                            </div>
                        </div>
                        <div className="courseblock adaptive_bottom_block">
                            <span
                                className="link-progress"
                                onClick={() => {
                                    startAttempt(0, 246);
                                }}>Start</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        startAttempt: (courseId, elementId) =>
            dispatch(startAttempt({ courseId, elementId })),
    };
};

export default withRouter(
    compose(
        connect(mapStateToProps, mapDispatchToProps),
        DefaultLayoutHOC,
    )(MyFreeActivities),
);
